import { useCallback } from 'react';
import { parseAsString, useQueryState } from 'nuqs';

import type { SortOption } from '../models';
import { useSortingOptions } from './use-sorting-options';

export const useAccessorialsControls = () => {
  const [sortParam, setSortParam] = useQueryState('sort', parseAsString.withDefault('date-newest'));
  const { data: sortOptions = [] } = useSortingOptions();

  const changeSort = useCallback(
    (option: SortOption | null) => {
      if (!option) {
        return;
      }
      setSortParam(option.id);
    },
    [setSortParam],
  );

  const deleteAccessorials = useCallback(() => {
    console.log('Delete selected accessorials');
  }, []);

  const addAccessorial = useCallback(() => {
    console.log('Add accessorial');
  }, []);

  // todo compute disabled flags based on selected items
  const isDeleteDisabled = true;

  return {
    addAccessorial,
    changeSort,
    deleteAccessorials,
    isDeleteDisabled,
    selectedSortOption: sortOptions.find((o) => o.id === sortParam),
    sortOptions,
  };
};
